const compareBrands = (brand1: string | null | undefined, brand2: string | null | undefined) => {
  return brand1?.toLowerCase() === brand2?.toLowerCase();
};

export default compareBrands;
